import React, { useMemo, useState } from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { getAllPartnersList } from '../../../../../../../../redux/fetchActions/legadoPage/clientsApp';
import { setPartnerOption } from '../../../../../../../../redux/fetchActions/legadoPage/faresApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';
import GetPartners from './components/GetPartners';

function SetPartner() {
  const dispatch = useDispatch();
  const [isDisable, setIsDisable] = useState(true);

  const profileUserState = useSelector(
    (reducer: IReducer) => reducer.userProfile
  );
  const profilePartnerState = useSelector(
    (reducer: IReducer) => reducer.partnerProfile
  );
  const filterState = useSelector(
    (reducer: IReducer) => reducer.clientsApp.partnersList
  );
  const faresFilterState = useSelector(
    (reducer: IReducer) => reducer.faresFilter
  );

  function setAccount(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setPartnerOption(value));
  }

  const [partnerFilter, setPartnerFilter] = useState(filterState);

  useMemo(() => {
    if (profileUserState.nivel === 2) {
      dispatch(getAllPartnersList());
      setIsDisable(false);
    } else {
      dispatch(getAllPartnersList());
      dispatch(setPartnerOption(profilePartnerState.idLegado.toString()));
      setIsDisable(true);
    }
  }, [profileUserState.nivel]);

  useMemo(() => {
    setPartnerFilter(filterState);
  }, [filterState]);

  const globalOption = useMemo(() => {
    if (faresFilterState.fare === 'receita') {
      dispatch(setPartnerOption(profilePartnerState.idLegado.toString()));
      return <></>;
    }
    return (
      <option key={0} value="global">
        Global (382)
      </option>
    );
  }, [faresFilterState.fare]);

  return (
    <Wrapper.Default isActive={!isDisable} flexDirection="row">
      <span>Parceiro:</span>
      <Form.Control
        as="select"
        style={{ width: '10.5rem', margin: '0 0.5rem 0 0.25rem' }}
        value={faresFilterState.partner}
        onChange={(event) => setAccount(event)}>
        {globalOption}
        <GetPartners partnerFilter={partnerFilter} />
      </Form.Control>
    </Wrapper.Default>
  );
}

export default SetPartner;
